module.exports = {
  INTERNATIONAL_AIR: "1*0",
  TWO_DAY: "1*1",
  SUNDAY_10_30: "1*10",
  RETURN_TO_SHOP: "1*13",
  SUNDAY_12_00: "1*14",
  BEFORE_9: "1*15",
  SUNDAY: "1*16",
  SAMEDAY: "1*17",
  DPD_EGS_12_00: "1*19",
  NEXT_DAY: "1*2",
  EVENING: "1*21",
  TIMED: "1*22",
  HOMECALL: "1*23",
  SHIP_TO_SHOP: "1*24",
  DPD_IMPORT: "1*25",
  DPD_12_00: "1*3",
  DPD_10_30: "1*4",
  AFTERNOON: "1*5",
  SATURDAY: "1*6",
  SATURDAY_12_00: "1*7",
  SATURDAY_10_30: "1*8",
  DPD_CLASSIC: "1*9",
  INTERNATIONAL_AIR_LOCAL: "2*0",
  HOMECALL_LOCAL: "2*1",
  SUNDAY_10_30_LOCAL: "2*10",
  TWO_DAY_LOCAL: "2*11",
  NEXT_DAY_LOCAL: "2*12",
  RETURN_TO_SHOP_LOCAL: "2*13",
  SUNDAY_12_00_LOCAL: "2*14",
  SUNDAY_LOCAL: "2*16",
  BY_15_00_LOCAL: "2*2",
  SHIP_TO_SHOP_LOCAL: "2*24",
  DPD_IMPORT_LOCAL: "2*25",
  BY_12_00_LOCAL: "2*3",
  BY_10_30_LOCAL: "2*4",
  SATURDAY_12_00_LOCAL: "2*6",
  SATURDAY_LOCAL: "2*7",
  SATURDAY_10_30_LOCAL: "2*8",
  DPD_CLASSIC_LOCAL: "2*9",
  NOTHING_TO_COLLECT: "2*99",
};
